import indicationsHistory from "@/plugins/api/factories/IndicationsHistory";

export const state = {
  indicationsHistory: [],
  isLoading: false,
};

export const actions = {
  async getAllIndicationsHistory({ commit, rootState }, { accountId } = {}) {
    // Используем переданный accountId, если он есть, иначе берем из текущего аккаунта
    const ls = accountId || rootState.Auth.account.ls;
    const cacheKey = `indicationsHistory_${ls}`;

    // 1. Попробовать загрузить данные из кеша
    const cachedHistory = localStorage.getItem(cacheKey);
    if (cachedHistory) {
      try {
        commit("SET_INDICATIONS_HISTORY", JSON.parse(cachedHistory));
      } catch (e) {
        console.error("Ошибка парсинга кеша истории показаний:", e);
      }
    }

    // 2. Если кеша нет, показать скелетон
    if (!cachedHistory) {
      commit("SET_IS_LOADING", true);
    }

    const credentials = rootState.Auth.userCredentials;
    const sessionId = rootState.Auth.sessionId;

    if (!sessionId && !credentials) {
      commit("SET_IS_LOADING", false);
      return;
    }

    // 3. В любом случае запросить свежие данные в фоне
    await indicationsHistory.getAllReadings(
      ls,
      credentials,
      (response) => {
        if (response && response.items) {
          commit("SET_INDICATIONS_HISTORY", response.items);
          // 4. Сохранить свежие данные в кеш
          localStorage.setItem(cacheKey, JSON.stringify(response.items));
        }
        // 5. Скрыть скелетон после получения ответа
        commit("SET_IS_LOADING", false);
      },
      sessionId
    );
  },
};

export const mutations = {
  SET_INDICATIONS_HISTORY(state, indicationsHistory) {
    state.indicationsHistory = indicationsHistory;
  },
  SET_IS_LOADING(state, isLoading) {
    state.isLoading = isLoading;
  },
};
